export default __webpack_public_path__ + "img/instra3.1e04c4d6.jpg";